function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a8db3b40-e925-4782-a6f8-83c79411f3a6{fill:#fbbc0f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a8db3b40-e925-4782-a6f8-83c79411f3a6",
  d: "M43.54,53.24,28.82,42.48a1.43,1.43,0,0,0-1.69,0L12.35,53.15a1.44,1.44,0,0,1-2.21-1.61L15.83,34.2a1.45,1.45,0,0,0-.51-1.6L.62,21.72a1.44,1.44,0,0,1,.85-2.6H19.68a1.42,1.42,0,0,0,1.36-1L26.73,1A1.44,1.44,0,0,1,28.52,0a1.43,1.43,0,0,1,.94.94L35,18.32a1.45,1.45,0,0,0,1.37,1H54.62a1.44,1.44,0,0,1,.84,2.6L40.69,32.67a1.44,1.44,0,0,0-.52,1.6l5.59,17.37a1.44,1.44,0,0,1-2.22,1.6Z",
  transform: "translate(-0.03 0.04)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a8db3b40-e925-4782-a6f8-83c79411f3a6",
  d: "M117.36,53.24,102.62,42.48a1.43,1.43,0,0,0-1.69,0L86.17,53.15A1.44,1.44,0,0,1,84,51.54L89.62,34.2a1.44,1.44,0,0,0-.52-1.6L74.41,21.72a1.44,1.44,0,0,1,.85-2.6H93.5a1.42,1.42,0,0,0,1.36-1L100.55,1A1.44,1.44,0,0,1,102.34,0a1.43,1.43,0,0,1,.94.94l5.58,17.36a1.45,1.45,0,0,0,1.37,1h18.23a1.44,1.44,0,0,1,.84,2.6L114.51,32.67a1.44,1.44,0,0,0-.52,1.6l5.63,17.37a1.44,1.44,0,0,1-2.26,1.6Z",
  transform: "translate(-0.03 0.04)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a8db3b40-e925-4782-a6f8-83c79411f3a6",
  d: "M191.18,53.24,176.46,42.48a1.43,1.43,0,0,0-1.69,0L160,53.15a1.44,1.44,0,0,1-2.21-1.61l5.69-17.34a1.44,1.44,0,0,0-.52-1.6L148.22,21.72a1.44,1.44,0,0,1-.31-2,1.47,1.47,0,0,1,1.17-.59h18.24a1.42,1.42,0,0,0,1.36-1L174.37,1A1.44,1.44,0,0,1,176.16,0a1.43,1.43,0,0,1,.94.94l5.58,17.36a1.43,1.43,0,0,0,1.37,1h18.22a1.44,1.44,0,0,1,.85,2.6L188.33,32.67a1.44,1.44,0,0,0-.52,1.6l5.59,17.37a1.44,1.44,0,0,1-2.22,1.6Z",
  transform: "translate(-0.03 0.04)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a8db3b40-e925-4782-a6f8-83c79411f3a6",
  d: "M265,53.24,250.28,42.48a1.43,1.43,0,0,0-1.69,0L233.81,53.15a1.43,1.43,0,0,1-2-.38,1.41,1.41,0,0,1-.19-1.23l5.69-17.34a1.44,1.44,0,0,0-.52-1.6L222,21.72a1.44,1.44,0,0,1-.31-2,1.47,1.47,0,0,1,1.17-.59h18.24a1.42,1.42,0,0,0,1.36-1L248.18,1A1.44,1.44,0,0,1,250,0a1.46,1.46,0,0,1,.93.93l5.58,17.36a1.43,1.43,0,0,0,1.37,1h18.22a1.44,1.44,0,0,1,.85,2.6L262.15,32.67a1.45,1.45,0,0,0-.53,1.65l5.59,17.37A1.44,1.44,0,0,1,265,53.24Z",
  transform: "translate(-0.03 0.04)"
});

var SvgGoogle4Stars = function SvgGoogle4Stars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a1c7be1f-c428-4041-960c-ec94687793a3",
    "data-name": "b45dd988-6433-46e2-8627-1a2e088b0163",
    viewBox: "0 0 277.49 53.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle4Stars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-4-stars.af512ae9.svg";
export { ForwardRef as ReactComponent };